$.fn.AudioCard = function() {
  let self = this

  if (self.data('audio-card')) {
    return self.data('audio-card')
  }

  self.play_pause = function() {
    self.toggleClass('card-audio--playing')
    return false
  }

  return function() {
    self.on('click', self.play_pause)
    self.data('audio-card', self)
    return self
  }()
}
